// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { backfillEmailDomainCreatedSubUserRequestToJson, backfillEmailDomainCreatedSubUserResponseFromJson, changeEmailDomainRequestToJson, changeEmailDomainResponseFromJson, createEmailDomainRequestToJson, createEmailDomainWithSendAsRequestToJson, deleteEmailDomainRequestToJson, deletePendingEmailDomainRequestToJson, getEmailDomainRequestToJson, getEmailDomainResponseFromJson, getEmailQueuesStatusRequestToJson, getEmailQueuesStatusResponseFromJson, getPendingEmailDomainRequestToJson, getPendingEmailDomainResponseFromJson, listEmailsRequestToJson, listEmailsResponseFromJson, sendRequestToJson, sendResponseFromJson, sendV2RequestToJson, sendV2ResponseFromJson, sendWithCustomDomainRequestToJson, sendWithCustomDomainResponseFromJson, setEmailQueuesStatusRequestToJson, verifyEmailDomainRequestToJson, verifyPendingEmailDomainRequestToJson, verifyPendingEmailDomainResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function send(request) {
    const raw = await fetchRpc('email.v1.EmailService/Send', sendRequestToJson(request));
    return sendResponseFromJson(raw);
}
export function send$(request, options) {
    return defer(() => sendWithTransport$(getGlobalTransport(), request, options));
}
export function sendWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/Send', sendRequestToJson(request), options)
        .pipe(map(resp => sendResponseFromJson(resp)));
}
export async function sendWithCustomDomain(request) {
    const raw = await fetchRpc('email.v1.EmailService/SendWithCustomDomain', sendWithCustomDomainRequestToJson(request));
    return sendWithCustomDomainResponseFromJson(raw);
}
export function sendWithCustomDomain$(request, options) {
    return defer(() => sendWithCustomDomainWithTransport$(getGlobalTransport(), request, options));
}
export function sendWithCustomDomainWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/SendWithCustomDomain', sendWithCustomDomainRequestToJson(request), options)
        .pipe(map(resp => sendWithCustomDomainResponseFromJson(resp)));
}
export async function sendV2(request) {
    const raw = await fetchRpc('email.v1.EmailService/SendV2', sendV2RequestToJson(request));
    return sendV2ResponseFromJson(raw);
}
export function sendV2$(request, options) {
    return defer(() => sendV2WithTransport$(getGlobalTransport(), request, options));
}
export function sendV2WithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/SendV2', sendV2RequestToJson(request), options)
        .pipe(map(resp => sendV2ResponseFromJson(resp)));
}
export async function list(request) {
    const raw = await fetchRpc('email.v1.EmailService/List', listEmailsRequestToJson(request));
    return listEmailsResponseFromJson(raw);
}
export function list$(request, options) {
    return defer(() => listWithTransport$(getGlobalTransport(), request, options));
}
export function listWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/List', listEmailsRequestToJson(request), options)
        .pipe(map(resp => listEmailsResponseFromJson(resp)));
}
export async function getEmailQueuesStatus(request) {
    const raw = await fetchRpc('email.v1.EmailService/GetEmailQueuesStatus', getEmailQueuesStatusRequestToJson(request));
    return getEmailQueuesStatusResponseFromJson(raw);
}
export function getEmailQueuesStatus$(request, options) {
    return defer(() => getEmailQueuesStatusWithTransport$(getGlobalTransport(), request, options));
}
export function getEmailQueuesStatusWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/GetEmailQueuesStatus', getEmailQueuesStatusRequestToJson(request), options)
        .pipe(map(resp => getEmailQueuesStatusResponseFromJson(resp)));
}
export async function setEmailQueuesStatus(request) {
    await fetchRpc('email.v1.EmailService/SetEmailQueuesStatus', setEmailQueuesStatusRequestToJson(request));
}
export function setEmailQueuesStatus$(request, options) {
    return defer(() => setEmailQueuesStatusWithTransport$(getGlobalTransport(), request, options));
}
export function setEmailQueuesStatusWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/SetEmailQueuesStatus', setEmailQueuesStatusRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getEmailDomain(request) {
    const raw = await fetchRpc('email.v1.EmailService/GetEmailDomain', getEmailDomainRequestToJson(request));
    return getEmailDomainResponseFromJson(raw);
}
export function getEmailDomain$(request, options) {
    return defer(() => getEmailDomainWithTransport$(getGlobalTransport(), request, options));
}
export function getEmailDomainWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/GetEmailDomain', getEmailDomainRequestToJson(request), options)
        .pipe(map(resp => getEmailDomainResponseFromJson(resp)));
}
export async function backfillEmailDomainCreatedSubUser(request) {
    const raw = await fetchRpc('email.v1.EmailService/BackfillEmailDomainCreatedSubUser', backfillEmailDomainCreatedSubUserRequestToJson(request));
    return backfillEmailDomainCreatedSubUserResponseFromJson(raw);
}
export function backfillEmailDomainCreatedSubUser$(request, options) {
    return defer(() => backfillEmailDomainCreatedSubUserWithTransport$(getGlobalTransport(), request, options));
}
export function backfillEmailDomainCreatedSubUserWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/BackfillEmailDomainCreatedSubUser', backfillEmailDomainCreatedSubUserRequestToJson(request), options)
        .pipe(map(resp => backfillEmailDomainCreatedSubUserResponseFromJson(resp)));
}
export async function createEmailDomain(request) {
    await fetchRpc('email.v1.EmailService/CreateEmailDomain', createEmailDomainRequestToJson(request));
}
export function createEmailDomain$(request, options) {
    return defer(() => createEmailDomainWithTransport$(getGlobalTransport(), request, options));
}
export function createEmailDomainWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/CreateEmailDomain', createEmailDomainRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function createEmailDomainWithSendAs(request) {
    await fetchRpc('email.v1.EmailService/CreateEmailDomainWithSendAs', createEmailDomainWithSendAsRequestToJson(request));
}
export function createEmailDomainWithSendAs$(request, options) {
    return defer(() => createEmailDomainWithSendAsWithTransport$(getGlobalTransport(), request, options));
}
export function createEmailDomainWithSendAsWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/CreateEmailDomainWithSendAs', createEmailDomainWithSendAsRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function verifyEmailDomain(request) {
    const raw = await fetchRpc('email.v1.EmailService/VerifyEmailDomain', verifyEmailDomainRequestToJson(request));
    return getEmailDomainResponseFromJson(raw);
}
export function verifyEmailDomain$(request, options) {
    return defer(() => verifyEmailDomainWithTransport$(getGlobalTransport(), request, options));
}
export function verifyEmailDomainWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/VerifyEmailDomain', verifyEmailDomainRequestToJson(request), options)
        .pipe(map(resp => getEmailDomainResponseFromJson(resp)));
}
export async function deleteEmailDomain(request) {
    await fetchRpc('email.v1.EmailService/DeleteEmailDomain', deleteEmailDomainRequestToJson(request));
}
export function deleteEmailDomain$(request, options) {
    return defer(() => deleteEmailDomainWithTransport$(getGlobalTransport(), request, options));
}
export function deleteEmailDomainWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/DeleteEmailDomain', deleteEmailDomainRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function changeEmailDomain(request) {
    const raw = await fetchRpc('email.v1.EmailService/ChangeEmailDomain', changeEmailDomainRequestToJson(request));
    return changeEmailDomainResponseFromJson(raw);
}
export function changeEmailDomain$(request, options) {
    return defer(() => changeEmailDomainWithTransport$(getGlobalTransport(), request, options));
}
export function changeEmailDomainWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/ChangeEmailDomain', changeEmailDomainRequestToJson(request), options)
        .pipe(map(resp => changeEmailDomainResponseFromJson(resp)));
}
export async function getPendingEmailDomain(request) {
    const raw = await fetchRpc('email.v1.EmailService/GetPendingEmailDomain', getPendingEmailDomainRequestToJson(request));
    return getPendingEmailDomainResponseFromJson(raw);
}
export function getPendingEmailDomain$(request, options) {
    return defer(() => getPendingEmailDomainWithTransport$(getGlobalTransport(), request, options));
}
export function getPendingEmailDomainWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/GetPendingEmailDomain', getPendingEmailDomainRequestToJson(request), options)
        .pipe(map(resp => getPendingEmailDomainResponseFromJson(resp)));
}
export async function verifyPendingEmailDomain(request) {
    const raw = await fetchRpc('email.v1.EmailService/VerifyPendingEmailDomain', verifyPendingEmailDomainRequestToJson(request));
    return verifyPendingEmailDomainResponseFromJson(raw);
}
export function verifyPendingEmailDomain$(request, options) {
    return defer(() => verifyPendingEmailDomainWithTransport$(getGlobalTransport(), request, options));
}
export function verifyPendingEmailDomainWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/VerifyPendingEmailDomain', verifyPendingEmailDomainRequestToJson(request), options)
        .pipe(map(resp => verifyPendingEmailDomainResponseFromJson(resp)));
}
export async function deletePendingEmailDomain(request) {
    await fetchRpc('email.v1.EmailService/DeletePendingEmailDomain', deletePendingEmailDomainRequestToJson(request));
}
export function deletePendingEmailDomain$(request, options) {
    return defer(() => deletePendingEmailDomainWithTransport$(getGlobalTransport(), request, options));
}
export function deletePendingEmailDomainWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.EmailService/DeletePendingEmailDomain', deletePendingEmailDomainRequestToJson(request), options)
        .pipe(map(() => undefined));
}
